import { Component, OnInit, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { AccountingModel } from './accountingModel.model';
import { AccountingModelService } from './accountingModel.service';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { CoreService } from '../../../core/header/core.service';
import { MatDialog } from '@angular/material/dialog';
import { AccountingModelDialogDeleteComponent } from './accountingModel-dialog-delete.component';
import { AccountingModelConst } from '../const';
import { DummyComponent } from '../../../shared/dummy.component';
import { CoreComponent } from '../../../core/header/core.component';
import { UserCompanyService } from '../usercompany/usercompany.service';
import { UserCompanyModel } from '../usercompany/usercompany.model';
import { AccountingModelComponent } from './accountingModel.component';
import { AccountingModelImportComponent } from './accountingModel-import.component';

@Component({
    selector: 'convfact-accountingModel-list',
    templateUrl: './accountingModel-list.component.html',
    styleUrls: ['./accountingModel.component.css'],
    standalone: false
})

export class AccountingModelListComponent implements OnInit {

  constructor(
    private router: Router,
    private accountingModelService: AccountingModelService,
    public snackBar: MatSnackBar,
    private coreService: CoreService,
    public dialog: MatDialog,
    private dummy: DummyComponent,
    private core: CoreComponent,
    private userCompanyService: UserCompanyService
  ) { }

  dataSource: AccountingModel[] = [];
  userCompany: UserCompanyModel;
  empty = false;
  ready = false;
  useConvfactAccount = true;
  headerTable: any[] = AccountingModelConst.headerTable;

  displayInfo(message: string): void {
    const options = new MatSnackBarConfig();
    options.duration = 10000;
    options.panelClass = ['custom-snackbar', 'custom-snackbar-container']; this.snackBar.open(message, '', options);
  }

  import() {
    this.dialog.open(AccountingModelImportComponent, {
      height: '500px',
    });
  }

  create(): void {
    const uid = null;
    this.dialog.open(AccountingModelComponent, {
      width: '650px',
      data: { uid: uid }
    })
  }

  edit(uid: string): void {
    this.dialog.open(AccountingModelComponent, {
      data: { uid: uid }
    })
  }

  delete(uid: string) {
    this.dialog.open(AccountingModelDialogDeleteComponent, {
      data: { uid: uid }
    })
      .afterClosed().subscribe(result => {
        this.core.refresh();
        this.dummy.redirectTo(this.router.url);
      });
  }

  ngOnInit() {
    this.coreService.setName('Plan contable');

    /* NO USADO
    this.accountingModelService.getList().then(
      data => {
        this.dataSource = data;
        if (this.dataSource.length === 0) {
          this.empty = true;
        } else {
          this.empty = false;
        }
        this.userCompanyService.loadData().then(response => {
          this.userCompany = response;

          this.ready = true;
        })
      }
    );*/
  }

}
